
class SnilsValidator {

	regexp = /^(\d{3}-\d{3}-\d{3} \d{2})$/;
	message?: string;

	validate = ( value: string ): boolean => {
		//если пусто, то считается валидным
		//такая логика в десктопе
		if ( value === "" || value === null ) return true;
		this.message = 'СНИЛС указан не полностью';
		if (!this.regexp.test(value))
			return false;

		value = value.replace(/-/g, '');
		const number = parseInt(value.substring(0, 9));
		const checksum = parseInt(value.substring(10, 12));

		if (number < 1001998)
			return true;
		
		let d = 0;
		for (var i = 0; i < 9; i++) {
			d += (9 - i) * parseInt(value[i]);
		}
		if (d === 101 || d === 100)
			d = 0;
		else
			d = d % 101 % 100;

		this.message = 'Некорректный СНИЛС';
		return d === checksum;
	};
	
};

export default SnilsValidator;
